export default "__VITE_ASSET__33372f81__"